import React from "react";
import styled from "styled-components";

import Device from "@/utils/device";
import colours from "../../../utils/colours";

type StyleProps = {
  animationColour?: string;
  colour?: string;
};

type StepForwardLinkProps = {
  linkText: string;
  href: string;
  animationColour?: string;
  colour?: string;
  target?: string;
};

const StepForwardLink: React.FC<StepForwardLinkProps> = (props) => {
  return (
    <S.ContentContainer tabIndex={0} {...props}>
      <S.A data-cy="SF-link" target="_blank" href={props.href} {...props}>
        {props.linkText}
        <S.Arrow {...props} />
      </S.A>
    </S.ContentContainer>
  );
};

const S = () => {};

S.ContentContainer = styled.span<StyleProps>`
  height: 20px;
  width: fit-content;
  position: relative;
  display: flex;
  align-items: center;
  padding: 15px 15px 15px 12px;
  cursor: pointer;

  &::before {
    position: absolute;
    height: 40%;
    width: 100%;
    content: "";
    left: 0;
    bottom: 0;
    border-left: 1px solid ${(p) => p.colour || colours.charcoal};
    border-bottom: 1px solid ${(p) => p.colour || colours.charcoal};
  }

  @media ${Device.mobile} {
    padding: 10px 30px 20px 15px;
  }

  &:hover > * {
    background-position: 0 0;
  }

  &:focus-visible > * {
    background-position: 0 0;
  }
`;

S.A = styled.a<StyleProps>`
  text-decoration: none;
  display: inline-block;
  font-weight: 700;
  font-size: 14px;
  color: transparent;
  overflow: hidden;
  -webkit-background-clip: text;
  background-clip: text;
  background-image: linear-gradient(
    to right,
    ${(p) => p.animationColour || colours.academyOrange} 50%,
    ${(p) => p.colour || colours.charcoal} 50%
  ); /* Black to White */
  transition: background-position 0.4s ease;
  background-size: 200% 100%;
  background-position: 100% 0;

  @media ${Device.tablet} {
    font-size: 16px;
  }

  @media ${Device.mobile} {
    font-size: 18px;
  }
`;

S.Arrow = styled.span<StyleProps>`
  position: absolute;
  bottom: -3px;
  right: -10px;
  display: inline-block;
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-left: 9px solid ${(p) => p.colour || colours.charcoal};
  margin-left: 15px;
`;

export default StepForwardLink;
